/*
===============================================================================================================
                                 Copyright 2022-2022, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React from 'react';
import LoadingArc from '@/components/loading-arc';

export default function LoadingScreen() {
  return (
    <div>
      <LoadingArc />
      <style jsx>
        {`
          div {
            position: fixed;
            left: 0;
            top: 0;
            width: 100vw;
            height: 100vh;
            background-color: var(--color-white);
          }
        `}
      </style>
    </div>
  );
}
